module.exports = __webpack_public_path__ + "assets/img/eyes-hit.eb2d0d8d.png";